import { UserRound } from 'lucide-react'

/** Stand-in avatar for a ticket holder who isn't on Faro (a typed name). */
export function OffAppAvatar() {
  return (
    <span className="flex size-6 shrink-0 items-center justify-center rounded-full bg-muted text-muted-foreground">
      <UserRound className="size-3.5" />
    </span>
  )
}
